(() => {
  function initShopAllMegaMenu() {
    document.querySelectorAll('.shop-all-mega').forEach((menu) => {
      if (menu.dataset.initialized === 'true') return;
      menu.dataset.initialized = 'true';

    const details = menu.closest('details');

if (details) {
  details.addEventListener('mouseenter', () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      details.open = true;
    }
  });

  details.addEventListener('mouseleave', () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      details.open = false;

      const submenu = menu.closest('.shop-all-submenu');

      if (submenu) {
        submenu.classList.remove('shop-all-expanded');
      }
    }
  });
}

      const categories = menu.querySelectorAll('[data-shop-all-category]');
      const panels = menu.querySelectorAll('[data-shop-all-panel]');

   function activateCategory(category, expand = true) {
  const panelId = category.dataset.panel;
  const submenu = menu.closest('.shop-all-submenu');

  const targetPanel = Array.from(panels).find(
    (panel) => panel.id === panelId
  );

  categories.forEach((item) => {
    const active = item === category;
    item.classList.toggle('is-active', active);

    if (active) {
      item.setAttribute('aria-current', 'true');
    } else {
      item.removeAttribute('aria-current');
    }
  });

  panels.forEach((panel) => {
    panel.classList.toggle(
      'is-active',
      Boolean(targetPanel) && panel === targetPanel
    );
  });

  if (submenu) {
    submenu.classList.toggle(
      'shop-all-expanded',
      Boolean(targetPanel) && expand
    );
  }
}


categories.forEach((category) => {
  // Hovering highlights the category.
  // Expand only if it has subcategories.
  category.addEventListener('mouseenter', () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      activateCategory(category, false);
    }
  });

  // Clicking expands the right panel only if subcategories exist.
  category.addEventListener('click', (event) => {
    const submenu = menu.closest('.shop-all-submenu');
    const panelId = category.dataset.panel;

    const hasSubcategories = Array.from(panels).some(
      (panel) => panel.id === panelId
    );

    if (
      hasSubcategories &&
      submenu &&
      !submenu.classList.contains('shop-all-expanded')
    ) {
      event.preventDefault();
      activateCategory(category, true);
    }
  });

  // Keyboard focus highlights the category.
  category.addEventListener('focus', () => {
    activateCategory(category, false);
  });
});


      categories.forEach((category) => {
        category.addEventListener('mouseenter', () => {
          activateCategory(category);
        });

        category.addEventListener('focus', () => {
          activateCategory(category);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopAllMegaMenu);
  } else {
    initShopAllMegaMenu();
  }

  document.addEventListener('shopify:section:load', initShopAllMegaMenu);
})();